export const seoOverrides = ["overrideSeo"];
